<template>
  <section class="container-fluid"></section>
</template>

<script lang="ts">
export default {
  name: "InboxNotificationsWebSocket",
};
</script>

<script lang="ts" setup>
// @ts-nocheck
import { useInboxWebSocket } from "vue-app/composables/useInboxWebSocket.ts";

useInboxWebSocket((event) => {
  const data = JSON.parse(event.data);
  if (data.type === "NOTIFICATION") {
    showMessageToast(data);
  }
});

function showMessageToast(data) {
  const message = data?.message;

  if (message && typeof message === "string" && window.EDRONE_CONTEXT.user.inboxNotification) {
    toggleDocumentTitleWithMessageIcon();

    if (!window.location.pathname.includes("inbox")) {
      // do not show toast if user is already on inbox page

      window.showToast(
        {
          message: window._trans["New inbox message"],
          link: {
            text: window._trans["View message"],
            url: data.url,
          },
        },
        "inbox"
      );
    }
  }
}

window.addEventListener(
  "focus",
  function () {
    if (window.documentTitleSwitcher) {
      clearInterval(window.documentTitleSwitcher);
      document.title = "edrone - Inbox";
      window.documentTitleSwitcher = undefined;
    }
  },
  false
);

function toggleDocumentTitleWithMessageIcon() {
  if (!document.hasFocus()) {
    window.previousDocumentTitle = document.title;
    window.titleSwitcher = 0;
    if (window.documentTitleSwitcher === undefined) {
      window.documentTitleSwitcher = setInterval(() => {
        if (window.titleSwitcher === 0) {
          window.titleSwitcher = 1;
          document.title = window._trans["New inbox message"];
        } else {
          window.titleSwitcher = 0;
          document.title = window.previousDocumentTitle;
        }
      }, 500);
    }
  }
}
</script>
